import { ApiConcept, ApiConceptRelation } from 'types/swagger/clarifai-api';
import { getRelation } from 'api-proxy/private/getOrCreateConceptRelation/getRelation';
import { createNewRelation } from 'api-proxy/private/getOrCreateConceptRelation/createNewRelation';
import { fetchAllConceptRelations } from 'api-proxy/private/getOrCreateConceptRelation/fetchAllConceptRelations';

type GetOrCreateConceptRelationProps = {
  request: {
    userOrOrgId: string;
    appId: string;
  };
  appConcept: ApiConcept;
  aiConcept: ApiConcept;
};

export const getOrCreateConceptRelation = async ({
  request,
  appConcept,
  aiConcept,
}: GetOrCreateConceptRelationProps): Promise<ApiConceptRelation | undefined> => {
  // Step 1: Find all concept relations
  const allConceptRelations = (await fetchAllConceptRelations({ request })) || [];

  // Step 2: Find existing relation
  const foundRelation = getRelation({ allConceptRelations, aiConcept, appConcept });

  if (foundRelation) return foundRelation;

  if (!appConcept.id) return undefined;

  const newRelation = await createNewRelation({
    request,
    subjectConceptId: appConcept.id,
    objectConcept: aiConcept,
  });

  if (newRelation) return newRelation;

  return undefined;
};
